import { BeneficiaryFilterEnumType, NULL_AS_STRING } from '@repo/shared/dtos/beneficiary'
import { EnumSchemaItem } from '@repo/shared/dtos/structured-data'
import { Button } from '@repo/ui/button'
import { Checkbox } from '@repo/ui/checkbox'
import { useT } from '@repo/ui/hooks'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@repo/ui/select'
import { useMemo, useState } from 'react'

import { FilterFormProps } from './types'

type EnumFilterFormProps = FilterFormProps<BeneficiaryFilterEnumType> & {
  schemaItem: EnumSchemaItem
}

export default function EnumFilterForm(props: EnumFilterFormProps) {
  const { filter, onChange, onCancel } = props
  const values = props.schemaItem.enumValues

  const [form, setForm] = useState<BeneficiaryFilterEnumType>(filter)
  const { t, tc } = useT({ keyPrefix: 'beneficiary.filters' })

  const isInvalid = useMemo(() => form.value.length === 0, [form.value])

  const handleValueChange = (value: string | null, checked: boolean) => {
    setForm({
      ...form,
      value: checked ? [...form.value, value] : form.value.filter((v) => v !== value),
    })
  }

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onCancel()
    onChange(form)
  }
  return (
    <form
      onSubmit={(event) => {
        handleSubmit(event)
      }}
      className="min-w-44 space-y-6"
    >
      <div className="space-y-4">
        <Select
          value={form.operator}
          onValueChange={(value) =>
            setForm({ ...form, operator: value as BeneficiaryFilterEnumType['operator'] })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Select an operator" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="in">{t('operators.in')}</SelectItem>
          </SelectContent>
        </Select>

        <div className="space-y-2">
          {values.map((value) => (
            <label className="flex items-center space-x-2" key={value}>
              <Checkbox
                value={value}
                checked={form.value.includes(value)}
                onCheckedChange={(checked) => handleValueChange(value, !!checked)}
              />
              <span className="text-primary-500 dark:text-primary-400 cursor-pointer text-sm uppercase">
                {value}
              </span>
            </label>
          ))}
          <label className="flex items-center space-x-2">
            <Checkbox
              value={NULL_AS_STRING}
              checked={form.value.includes(null)}
              onCheckedChange={(checked) => handleValueChange(null, !!checked)}
            />
            <span className="text-primary-500 dark:text-primary-400 cursor-pointer text-sm uppercase">
              {tc(NULL_AS_STRING)}
            </span>
          </label>
        </div>
      </div>

      <div className="flex justify-end gap-2">
        <Button type="button" onClick={onCancel} variant="ghost">
          {t('form.cancelButton')}
        </Button>
        <Button type="submit" disabled={isInvalid}>
          {t('form.applyButton')}
        </Button>
      </div>
    </form>
  )
}
